import clsx from 'clsx';
import { formatDistanceToNowStrict } from 'date-fns';
import { AmountListItem, AmountListItemProps } from '../List';
import { Icon } from '../Icon';

export interface AmountSumTableItemProps
  extends Pick<
    AmountListItemProps,
    | 'amount'
    | 'title'
    | 'className'
    | 'withChevron'
    | 'subtitle'
    | 'onClick'
    | 'onKeyDown'
    | 'linkStatus'
    | 'role'
    | 'dataTestID'
    | 'contentPrefix'
    | 'motionProps'
  > {
  decayed?: boolean;
  lastUpdated?: string;
  lastUpdatedPrefix?: string;
}

export function AmountSumTableItem({
  className,
  lastUpdated,
  lastUpdatedPrefix,
  decayed,
  motionProps,
  ...props
}: AmountSumTableItemProps) {
  return (
    <AmountListItem
      {...props}
      tabIndex={0}
      role="button"
      motionProps={motionProps ?? { whileFocus: { scale: 1.03, borderRadius: 8 } }}
      amountSubtitle={
        lastUpdated && (
          <div className="flex ">
            {decayed && <Icon icon="warning" className="text-darkMode-warning h-4 w-4 mr-[2px]" />}
            <span className="MonetaryListItem-amount-subtitle text-[13px] mt-[1px]">
              {lastUpdatedPrefix ? `${lastUpdatedPrefix} ` : ''}
              {formatDistanceToNowStrict(new Date(lastUpdated), { addSuffix: true })}
            </span>
          </div>
        )
      }
      className={clsx(
        [
          className,
          lastUpdated || props.subtitle ? '!min-h-[56px]' : '!min-h-[48px]',
          'pl-4 first:rounded-t-2xl last:rounded-b-2xl',
          props.withChevron ? 'pr-[6px]' : 'pr-[31px]',
          '[&_.MonetaryListItem-title-content]:!my-2',
          '[&_.ListItem-chevron]:!m-0',
        ],
        decayed && [
          'odd:bg-darkMode-warning/[0.10] even:bg-darkMode-warning/[0.03]',
          '[&_.ListItem-chevron_svg]:!text-darkMode-warning',
          '[&_.dollar-sign]:!text-darkMode-gray-light/40 [&_.dollar-sign]:!mix-blend-plus-lighter',
          '[&_.MonetaryListItem-subtitle]:!text-darkMode-gray-light/40 [&_.MonetaryListItem-subtitle]:!mix-blend-plus-lighter',
          '[&_.MonetaryListItem-title]:!text-darkMode-white/80',
          '[&_.MonetaryListItem-amount_*]:!text-darkMode-warning/80',
          '[&_.MonetaryListItem-amount-subtitle]:!text-darkMode-gray-light/40 [&_.MonetaryListItem-amount-subtitle]:!mix-blend-plus-lighter',
        ]
      )}
    />
  );
}
